import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3 row pt-0" }
const _hoisted_2 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_3 = { class: "col p-0" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_6 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_7 = { class: "col p-0" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_10 = { class: "form-group mb-2 col" }
const _hoisted_11 = { class: "col-auto p-0 text-end" }
const _hoisted_12 = {
  key: 0,
  class: "p-3 pt-0"
}
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "table table-striped border-light align-middle text-left" }
const _hoisted_15 = { class: "text-capitalize-first" }
const _hoisted_16 = { class: "text-capitalize-first" }
const _hoisted_17 = { class: "text-capitalize-first" }
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "d-flex flex-column mt-1 mb-1" }
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "text-secondary" }
const _hoisted_24 = { class: "d-flex flex-column" }
const _hoisted_25 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = {
  key: 3,
  class: "sensitive-data",
  style: {"word-break":"break-all"}
}
const _hoisted_30 = { class: "text-secondary" }
const _hoisted_31 = { class: "text-nowrap" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "text-danger" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["title"]
const _hoisted_37 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_TradeDealDetailsTable = _resolveComponent("TradeDealDetailsTable")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.filters.fromDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.fromDate) = $event)),
                mode: "dateTime",
                "model-modifiers": {string: true},
                is24hr: "",
                masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
              }, {
                default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                  _createElementVNode("input", {
                    class: "form-control form-control-sm",
                    placeholder: _ctx.helper.trans('labels.from_date'),
                    value: inputValue,
                    onFocus: togglePopover,
                    onChange: inputEvents.change
                  }, null, 40, _hoisted_5)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.filters.toDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.toDate) = $event)),
                mode: "dateTime",
                "model-modifiers": {string: true},
                is24hr: "",
                masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
              }, {
                default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                  _createElementVNode("input", {
                    class: "form-control form-control-sm",
                    placeholder: _ctx.helper.trans('labels.to_date'),
                    value: inputValue,
                    onFocus: togglePopover,
                    onChange: inputEvents.change
                  }, null, 40, _hoisted_9)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
              class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans('button.apply')), 1)
          ])
        ])
      ]),
      (_ctx.device)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.helper.trans('labels.id_date')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
                    _createElementVNode("th", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.message')) + " ", 1),
                      (_ctx.isAdmin || _ctx.isOperator)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                            (_ctx.helper.isSensitiveDataVisible())
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.helper.hideSensitiveData()), ["prevent"])),
                                  class: "fa fa-eye"
                                }))
                              : (_openBlock(), _createElementBlock("i", {
                                  key: 1,
                                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.helper.showSensitiveData()), ["prevent"])),
                                  class: "fa fa-eye-slash"
                                }))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.trade_deal')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedResponse.items, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: ""
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", null, [
                            _withDirectives((_openBlock(), _createElementBlock("span", {
                              title: item.log.message.id
                            }, [
                              _createTextVNode(_toDisplayString(item.log.message.id.substring(0, 8)) + "...", 1)
                            ], 8, _hoisted_22)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ]),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createVNode(_component_copy_button, {
                              value: item.log.message.id
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("small", _hoisted_23, _toDisplayString(_ctx.dateHelper.format(item.log.message.created_at)), 1)
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.log.message.status), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans(`message_log.type.${item.log.message.message_source.trigger}`)) + " - " + _toDisplayString(item.log.bank?.name), 1),
                          (item.log.message.user_agent)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(_ctx.parseUserAgent(item.log.message.user_agent)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        (item.log.message.message_source.trigger === 'app_push_notification')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("strong", null, _toDisplayString(item.log.message.message_source.app_push_notification.title), 1),
                              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(item.log.message.message_source.app_push_notification.notification), 1)
                            ]))
                          : (item.log.message.message_source.trigger === 'sms')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("strong", null, _toDisplayString(item.log.message.message_source.sms.number), 1),
                                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(" " + _toDisplayString(item.log.message.message_source.sms.message), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(JSON.stringify(item.log.message.message_source)), 1)),
                        (_ctx.isAdmin || _ctx.isOperator)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createElementVNode("small", _hoisted_30, [
                                _createTextVNode(_toDisplayString(item.log.message.message_parser_name) + " " + _toDisplayString(item.log.message.message_parser_version) + " ", 1),
                                _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(" " + _toDisplayString(JSON.stringify(item.log.message.message_parsing)), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_31, [
                        (!item.notification)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, " n/a "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.notification.errors, (error) => {
                                return (_openBlock(), _createElementBlock("div", { key: error }, [
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.helper.trans(`message_log.error.${error}`)), 1)
                                ]))
                              }), 128)),
                              (item.notification.dealId)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createElementVNode("span", null, [
                                      _withDirectives((_openBlock(), _createElementBlock("span", {
                                        title: item.notification.dealPublicId
                                      }, [
                                        _createTextVNode(_toDisplayString(item.notification.dealPublicId), 1)
                                      ], 8, _hoisted_36)), [
                                        [
                                          _directive_b_tooltip,
                                          void 0,
                                          void 0,
                                          { hover: true }
                                        ]
                                      ]),
                                      _cache[13] || (_cache[13] = _createTextVNode()),
                                      _createVNode(_component_copy_button, {
                                        value: item.notification.dealPublicId
                                      }, null, 8, ["value"])
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.showDealDetails(item.notification.dealId)),
                                      class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize ms-2"
                                    }, [
                                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa fa-list" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.details')), 1)
                                    ], 8, _hoisted_37)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (_ctx.paginatedResponse.totalCount > _ctx.paginatedResponse.items.length)
                ? (_openBlock(), _createBlock(_component_b_pagination, {
                    key: 0,
                    modelValue: _ctx.page,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page) = $event)),
                      _cache[6] || (_cache[6] = ($event: any) => (_ctx.load()))
                    ],
                    "total-rows": _ctx.paginatedResponse.totalCount,
                    "per-page": _ctx.paginatedResponse.limit,
                    limit: 20,
                    "prev-text": _ctx.helper.trans('button.back'),
                    "next-text": _ctx.helper.trans('button.next'),
                    align: "start",
                    "first-number": "",
                    "hide-goto-end-buttons": "",
                    "hide-ellipsis": ""
                  }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_b_modal, {
        title: "",
        "dialog-class": "modal-lg",
        modelValue: _ctx.dealDetailsModal,
        "footer-class": "d-flex justify-content-end",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dealDetailsModal = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderDealDetailsModal",
            class: "h-100"
          }, {
            default: _withCtx(() => [
              (_ctx.detailsDeal)
                ? (_openBlock(), _createBlock(_component_TradeDealDetailsTable, {
                    key: 0,
                    deal: _ctx.detailsDeal
                  }, null, 8, ["deal"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.dealDetailsModal = false), ["prevent"])),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 512))
}